"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMarquee = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dynamic_1 = __importDefault(require("next/dynamic"));
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
const DynamicMarquee = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('../components'))).then((mod) => mod.Marquee), { ssr: false });
exports.HeaderMarquee = (0, react_1.memo)(({ data }) => {
    return ((0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(DynamicMarquee, { data: data }) }));
});
const Header = styled_components_1.default.header `
  margin: 85px 0 ${(0, styles_1.vw)(35, 'mobile')};
  overflow: hidden;
  width: 100vw;

  ${styles_1.mq.greaterThan('tablet')} {
    margin: 80px 0 ${(0, styles_1.vw)(60, 'desktop')};
  }

  .marquee {
    background-color: unset;
    margin-top: ${(0, styles_1.vw)(25, 'mobile')};
    padding: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(30, 'desktop')};
      padding: 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 30px;
    }
  }
`;
